import React, { useEffect, useRef, useState } from "react";
import { Badge, Col, Collapse, Form, Modal, Offcanvas, Row, Spinner, Table } from "react-bootstrap";
import Moment from "react-moment";
import { LuSend } from "react-icons/lu";
import { FaRegCircleXmark } from "react-icons/fa6";
import { FaUser, FaUserShield } from "react-icons/fa";
import UseToggle from "../../../../Hooks/UseToggle";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const FieldQueryHistory = ({
  Show,
  Hide,
  Title,
  dataEntryQueryHistory,
  tableRef,
  onMouseDown,
  queryButtonLoader,
  genarateButtonLoader,
  queryDiscussionStudySubjectFormField,
  generateManualQueryStatusStudySubjectFormField,
  generateManualQueryStudySubjectFormFieldDataEntry,
  getStudySubjectFormFieldQueryDiscussionDataEntry,
  setResponseMessage,
  responseMessage,
  setQuerySubject,
  querySubject,
  setQueryMessage,
  queryMessage,
  fieldId,
  formFields,
  totalDataEntry,
  setSelectedRadioField,
  selectedRadioField,
  setReasonMessage,
  reasonMessage,
  dataEntryQueryDiscussion,
  queryDataLoader,
}) => {
  const [openChatModule, setOpenChatModule] = useState("");
  const [queryId, setQueryId] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const { toggle, setToggle} = UseToggle();
  const AppsRef = useRef(null);
  const [openAction, setOpenAction] = useState(false);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setOpenAction(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  useEffect(() => {
    setOpenAction(false)
    setSelectedRadioField("")
    setQuerySubject("")
    setQueryMessage("")
    setOpenChatModule("")
    setQueryId("")
  }, [Show]);

  let checkFieldData = formFields?.find(item => item.id === fieldId)
  let checkEntryStatus = totalDataEntry?.find(item => item.fieldId === fieldId)

  let fieldValue;
  if (checkFieldData?.type === "date") {
    fieldValue = `${checkEntryStatus?.day ?? ''}${checkEntryStatus?.month ? `-${checkEntryStatus.month}` : ''}${checkEntryStatus?.year ? `-${checkEntryStatus.year}` : ''}`;
  } else if (checkFieldData?.type === "time") {
    fieldValue = `${checkEntryStatus?.hour ?? ''}${checkEntryStatus?.minute ? `-${checkEntryStatus.minute}` : ''}${checkEntryStatus?.second ? `-${checkEntryStatus.second}` : ''} ${checkEntryStatus?.format ? `${checkEntryStatus.format}` : ''}`;
  } else if (checkFieldData?.type === "checkbox") {
    fieldValue = (checkEntryStatus?.value || [])?.join(", ")
  } else {
    fieldValue = checkEntryStatus?.value
  }

  let selectedDataFunction = () => {
    if (!(checkEntryStatus?.type.startsWith("custom") || checkFieldData?.fieldUnit === "yes" || checkFieldData?.customFieldRemark === "yes")) {
      setSelectedRadioField({
        name: checkFieldData?.fieldName,
        label: checkFieldData?.fieldLabel,
        value: fieldValue
      })
    }
  }

  useEffect(() => {
    selectedDataFunction()
  }, []);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: '700px' }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {Title}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {StudyMode?.startsWith("SDV") &&
            <div className="p-3" ref={AppsRef}>
              <div className="w-25">
                <button
                  onClick={() => { setOpenAction(!openAction); selectedDataFunction() }}
                  className={`updateProfile`}
                >
                  <span>Generate Query</span>
                </button>
              </div>
              <Collapse in={openAction === true}>
                <div>
                  <Row>
                    {(checkEntryStatus?.type.startsWith("custom") || checkFieldData?.fieldUnit === "yes" || checkFieldData?.customFieldRemark === "yes") &&
                      <Form.Group as={Col} md={12} className="mb-2">
                        <Form.Label className="fw-bold mb-1">
                          Fields{" "}
                          <abbr title="Required" className="text-danger">
                            *
                          </abbr>
                        </Form.Label>
                        <Form.Check
                          type="radio"
                          label={`${checkFieldData?.fieldLabel} (${checkFieldData?.fieldName})`}
                          name="queryField"
                          disabled={checkEntryStatus?.queryStatus === "open"}
                          checked={selectedRadioField?.name === checkFieldData?.fieldName}
                          onChange={(e) => setSelectedRadioField({ name: checkFieldData?.fieldName, label: checkFieldData?.fieldLabel, value: fieldValue })}
                        />
                        {(checkFieldData?.fieldUnit === "yes") && (
                          <Form.Check
                            type="radio"
                            label={`${checkFieldData?.fieldUnitLabel} (${checkFieldData?.fieldUnitName})`}
                            name="queryField"
                            disabled={!checkEntryStatus?.unit || checkEntryStatus?.unitQueryStatus === "open"}
                            checked={selectedRadioField?.name === checkFieldData?.fieldUnitName}
                            onChange={(e) => setSelectedRadioField({ name: checkFieldData?.fieldUnitName, label: checkFieldData?.fieldUnitLabel, value: checkEntryStatus?.unit })}
                          />
                        )}
                        {(checkFieldData?.customFieldRemark === "yes") && (
                          <Form.Check
                            type="radio"
                            label={`${checkFieldData?.customFieldRemarkLabel} (${checkFieldData?.customFieldRemarkName})`}
                            name="queryField"
                            disabled={!checkEntryStatus?.valueRemark || checkEntryStatus?.queryValueRemarkStatus === "open"}
                            checked={selectedRadioField?.name === checkFieldData?.customFieldRemarkName}
                            onChange={(e) => setSelectedRadioField({ name: checkFieldData?.customFieldRemarkName, label: checkFieldData?.customFieldRemarkLabel, value: checkEntryStatus?.valueRemark })}
                          />
                        )}
                        {checkEntryStatus?.type.startsWith("custom") &&
                          <>
                            {(checkFieldData?.referenceRangeLowerLimit === "yes") && (
                              <Form.Check
                                type="radio"
                                label={`${checkFieldData?.referenceRangeLowerLimitLabel} (${checkFieldData?.referenceRangeLowerLimitName})`}
                                name="queryField"
                                disabled={!checkEntryStatus?.referenceRangeLowerLimit || checkEntryStatus?.referenceRangeLowerLimitQueryStatus === "open"}
                                checked={selectedRadioField?.name === checkFieldData?.referenceRangeLowerLimitName}
                                onChange={(e) => setSelectedRadioField({ name: checkFieldData?.referenceRangeLowerLimitName, label: checkFieldData?.referenceRangeLowerLimitLabel, value: checkEntryStatus?.referenceRangeLowerLimit })
                                }
                              />
                            )}
                            {(checkFieldData?.referenceRangeUpperLimit === "yes") && (
                              <Form.Check
                                type="radio"
                                label={`${checkFieldData?.referenceRangeUpperLimitLabel} (${checkFieldData?.referenceRangeUpperLimitName})`}
                                name="queryField"
                                disabled={!checkEntryStatus?.referenceRangeUpperLimit || checkEntryStatus?.referenceRangeUpperLimitQueryStatus === "open"}
                                checked={selectedRadioField?.name === checkFieldData?.referenceRangeUpperLimitName}
                                onChange={(e) => setSelectedRadioField({ name: checkFieldData?.referenceRangeUpperLimitName, label: checkFieldData?.referenceRangeUpperLimitLabel, value: checkEntryStatus?.referenceRangeUpperLimit })
                                }
                              />
                            )}
                            {(checkFieldData?.referenceRangeIndicator === "yes") && (
                              <Form.Check
                                type="radio"
                                label={`${checkFieldData?.referenceRangeIndicatorLabel} (${checkFieldData?.referenceRangeIndicatorName})`}
                                name="queryField"
                                disabled={!checkEntryStatus?.referenceRangeIndicator || checkEntryStatus?.referenceRangeIndicatorQueryStatus === "open"}
                                checked={selectedRadioField?.name === checkFieldData?.referenceRangeIndicatorName}
                                onChange={(e) => setSelectedRadioField({ name: checkFieldData?.referenceRangeIndicatorName, label: checkFieldData?.referenceRangeIndicatorLabel, value: checkEntryStatus?.referenceRangeIndicator })
                                }
                              />
                            )}
                            {(checkFieldData?.clinicalSignificance === "yes") && (
                              <Form.Check
                                type="radio"
                                label={`${checkFieldData?.clinicalSignificanceLabel} (${checkFieldData?.clinicalSignificanceName})`}
                                name="queryField"
                                disabled={!checkEntryStatus?.clinicalSignificance || checkEntryStatus?.clinicalSignificanceQueryStatus === "open"}
                                checked={selectedRadioField?.name === checkFieldData?.clinicalSignificanceName}
                                onChange={(e) => setSelectedRadioField({ name: checkFieldData?.clinicalSignificanceName, label: checkFieldData?.clinicalSignificanceLabel, value: checkEntryStatus?.clinicalSignificance })
                                }
                              />
                            )}
                            {(checkFieldData?.customRemark === "yes") && (
                              <Form.Check
                                type="radio"
                                label={`${checkFieldData?.customRemarkLabel} (${checkFieldData?.customRemarkName})`}
                                name="queryField"
                                disabled={!checkEntryStatus?.remark || checkEntryStatus?.remarkQueryStatus === "open"}
                                checked={selectedRadioField?.name === checkFieldData?.customRemarkName}
                                onChange={(e) => setSelectedRadioField({ name: checkFieldData?.customRemarkName, label: checkFieldData?.customRemarkLabel, value: checkEntryStatus?.remark })
                                }
                              />
                            )}
                          </>
                        }
                      </Form.Group>
                    }
                    {(checkEntryStatus?.type.startsWith("custom") || checkFieldData?.fieldUnit === "yes" || checkFieldData?.customFieldRemark === "yes") ?
                      <>
                        <Form.Group as={Col} md={12} className="mb-2">
                          <Form.Label className="fw-bold mb-1">
                            Query Subject{" "}
                            <abbr title="Required" className="text-danger">
                              *
                            </abbr>
                          </Form.Label>
                          <Form.Control
                            className="br3"
                            onChange={(e) => setQuerySubject(e.target.value)}
                            value={querySubject}
                            placeholder="Query Subject"
                            type="text"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md={12} className="mb-2">
                          <Form.Label className="fw-bold mb-1">
                            Query Message{" "}
                            <abbr title="Required" className="text-danger">
                              *
                            </abbr>
                          </Form.Label>
                          <Form.Control
                            className="br3"
                            onChange={(e) => setQueryMessage(e.target.value)}
                            value={queryMessage}
                            placeholder="Query Message"
                            as="textarea"
                          />
                        </Form.Group>
                      </>
                      :
                      <>
                        <Form.Group as={Col} md={12} className="mb-2">
                          <Form.Label className="fw-bold mb-1">
                            Query Subject{" "}
                            <abbr title="Required" className="text-danger">
                              *
                            </abbr>
                          </Form.Label>
                          <Form.Control
                            className="br3"
                            onChange={(e) => setQuerySubject(e.target.value)}
                            value={querySubject}
                            disabled={checkEntryStatus?.queryStatus === "open"}
                            placeholder="Query Subject"
                            type="text"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md={12} className="mb-2">
                          <Form.Label className="fw-bold mb-1">
                            Query Message{" "}
                            <abbr title="Required" className="text-danger">
                              *
                            </abbr>
                          </Form.Label>
                          <Form.Control
                            className="br3"
                            onChange={(e) => setQueryMessage(e.target.value)}
                            value={queryMessage}
                            disabled={checkEntryStatus?.queryStatus === "open"}
                            placeholder="Query Message"
                            as="textarea"
                          />
                        </Form.Group>
                      </>
                    }
                  </Row>
                  <div className="text-end">
                    <button
                      disabled={!queryMessage || !querySubject || selectedRadioField?.name === 0 || genarateButtonLoader}
                      onClick={generateManualQueryStudySubjectFormFieldDataEntry}
                      className="updateProfile"
                      style={{ fontSize: 12 }}
                    >
                    {genarateButtonLoader ? <div className="hstack gap-2">
                      <Spinner size="sm"/> Generating...
                    </div>
                    : " Generate Now"
                    }
                     
                    </button>
                  </div>
                </div>
              </Collapse>
            </div>
          }
          {queryDataLoader ? 
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 44px)" }}
            >
              <PageLoader/>
            </div>
          : dataEntryQueryHistory?.length === 0 && !StudyMode?.startsWith("SDV") ?
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 44px)" }}
            >
              <NoDataFoundTable MSG={"Field query history not found!"} />
            </div>
         : dataEntryQueryHistory?.length > 0 &&
            <Table ref={tableRef} className="m-0 query-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th onMouseDown={(e) => onMouseDown(e, 0)} style={{ width: 45 }} className="text-center">
                    Sr.
                  </th>
                  <th>Field Name</th>
                  <th>Field Value</th>
                  <th>QueryId</th>
                  <th>Query Type</th>
                  <th>Query Status</th>
                  <th>Generated By</th>
                </tr>
              </thead>
              <tbody>
                {dataEntryQueryHistory?.map((item, index) => (
                  <>
                    <tr
                      key={index}
                      className={`${openChatModule === item?.queryId ? "selectedRow" : ""} CP`}
                      onClick={() => { setOpenChatModule(openChatModule === item?.queryId ? "" : item?.queryId); getStudySubjectFormFieldQueryDiscussionDataEntry(item?.queryId) }}>
                      <td className="text-center">{index + 1}.</td>
                      <td title={item?.fieldLabel}>{item?.fieldName}</td>
                      <td>{item?.fieldValue}</td>
                      <td>{item?.queryId}</td>
                      <td className="text-capitalize">{item?.queryType}</td>
                      <td className="text-capitalize">{item?.status}</td>
                      <td>{item?.generatedBy}</td>
                    </tr>
                    {dataEntryQueryDiscussion?.length > 0 &&
                      <Collapse in={openChatModule === item?.queryId}>
                        <tr>
                          <td colSpan={7} className="p-0">
                            <div className="hstack flex-column h-100 w-100 justify-content-between">
                              <div className="p-2 CP border-bottom hstack bg-white justify-content-between">
                                <div className="text-wrap"><b>Subject:</b> {item?.subject}</div><br />
                                <div style={{ width: 265 }} className="d-flex gap-2 CP">
                                  <Badge className="br3 text-dark" bg="success-subtle" style={{ fontSize: 12 }}>
                                    #{item?.queryId}
                                  </Badge>
                                  <Badge
                                    className="br3 text-dark border"
                                    bg={item?.status === "open" ? "danger-subtle" : "border-muted"}
                                    onClick={(e) => {
                                      if (!(item?.status === "open" || item?.status === "close" || item?.status === "cancel")) {
                                        generateManualQueryStatusStudySubjectFormField(item?.queryId, "open")
                                      }
                                    }}
                                    style={{ fontSize: 12 }}
                                  >
                                    Open
                                  </Badge>
                                  <Badge
                                    className="br3 text-dark border"
                                    bg={item?.status === "close" ? "success-subtle" : ""}
                                    onClick={(e) => {
                                      if (!(item?.status === "close" || item?.status === "cancel") && (StudyMode?.startsWith("SDV") || item?.queryType === "auto")) {
                                        generateManualQueryStatusStudySubjectFormField(item?.queryId, "close")
                                      }
                                    }}
                                    style={{ fontSize: 12 }}
                                  >
                                    Close
                                  </Badge>
                                  <Badge
                                    className="br3 text-dark border"
                                    bg={item?.status === "cancel" ? "secondary-subtle" : ""}
                                    onClick={(e) => {
                                      if (!(item?.status === "cancel" || item?.status === "close") && StudyMode?.startsWith("SDV")) {
                                        setQueryId(item?.queryId);
                                        setToggle()
                                      }
                                    }}
                                    style={{ fontSize: 12 }}
                                  >
                                    Cancel
                                  </Badge>
                                </div>
                              </div>
                              <div style={{ height: 200 }} className="w-100 p-2 overflow-auto bg-light">
                                {(dataEntryQueryDiscussion || []).map((chat, index) => (
                                  <div key={index} className="d-flex flex-column gap-2 mb-2">
                                    {chat.comment &&
                                      <div className="d-flex gap-2">
                                        <FaUserShield
                                          title={`User: ${chat.commentedBy}\nRole: SDV User`}
                                          className="CP"
                                          style={{ marginTop: 5, height: 18, width: 18 }}
                                        />
                                        <div style={{ maxWidth: 280 }}>
                                          <div className="px-2 lh-sm bg-danger-subtle p-2 br3">
                                            <div className="m-0 lh-sm text-wrap" style={{ fontSize: 12 }}>
                                              <p className="mb-1 fw-bold" style={{ fontSize: 12 }}>Query</p>
                                              {chat.comment}
                                            </div>
                                          </div>
                                          <div style={{ fontSize: 9 }}>
                                            Date | Time: <Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
                                              {chat.commentDate}
                                            </Moment>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    {chat.reply &&
                                      <div className="text-end">
                                        <div className="d-flex gap-2 justify-content-end">
                                          <div style={{ maxWidth: 280 }}>
                                            <div className="px-2 lh-sm text-end bg-success-subtle p-2 br3">
                                              <div className="m-0 lh-sm text-wrap" style={{ fontSize: 12 }}>
                                                <p className="mb-1 fw-bold" style={{ fontSize: 12 }}>Response</p>
                                                {chat.reply}
                                              </div>
                                            </div>
                                            <div style={{ fontSize: 9 }}>
                                              Date | Time: <Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
                                                {chat.replyDate}
                                              </Moment>
                                            </div>
                                          </div>
                                          <FaUser
                                            title={`User: ${chat.repliedBy}\nRole: Data Entry User`}
                                            className="CP"
                                            style={{ width: 17, height: 17 }}
                                          />
                                        </div>
                                      </div>
                                    }
                                  </div>
                                ))}
                              </div>
                              <div className="border-top w-100 bg-white">
                                <div className="hstack">
                                  <Form.Control
                                    type="text"
                                    onChange={(e) => setResponseMessage(e.target.value)}
                                    value={responseMessage}
                                    disabled={(item?.status === "close" || item?.status === "cancel")}
                                    className="w-100 rounded-0 border-0 border-end"
                                    placeholder="Write response..."
                                  />
                                  {(item?.status === "open") &&
                                    queryButtonLoader ? (
                                      <div className="hstack justify-content-center" style={{ width: 40 }}>
                                        <Spinner size="sm"/>
                                      </div>
                                    ) : (
                                      <LuSend
                                        onClick={() => queryDiscussionStudySubjectFormField(item?.queryId, StudyMode?.startsWith("SDV") ? "comment" : "reply")}
                                        style={{ width: 40 }}
                                        disabled={queryButtonLoader || (item?.status === "close" || item?.status === "cancel")}
                                        title="Send"
                                        className="CP"
                                      />
                                    )
                                  }
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </Collapse>
                    }
                  </>
                ))}
              </tbody>
            </Table>
          }
        </Offcanvas.Body>
      </Offcanvas>
      
      <Modal
        show={!toggle}
        onHide={setToggle}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="p-0">
          <div className="d-flex justify-content-between border-bottom py-2 px-3">
            <Form.Label style={{ fontSize: 16 }} className="fw-bold mb-0">
              Cancel Query{" "}
            </Form.Label>
            <FaRegCircleXmark onClick={() => { setToggle(); setReasonMessage("") }} style={{ fontSize: 18 }} className="text-danger CP" title="Close" />
          </div>
          <Form.Group className="py-2 px-3">
            <Form.Label className="fw-bold mb-1">
              Reason{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setReasonMessage(e.target.value)}
              value={reasonMessage}
              className="br3"
              placeholder="Reason for cancel query"
              as="textarea"
            />
            <div className="text-end mt-2 mb-0">
              <button
                disabled={!reasonMessage || !queryId}
                onClick={() => { generateManualQueryStatusStudySubjectFormField(queryId, "cancel"); setToggle(); }}
                className="updateProfile"
                style={{ fontSize: 12 }}
              >
                Cancel Query
              </button>
            </div>
          </Form.Group>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FieldQueryHistory;